import axios from "axios";
import { getURLbyEndPointV2 } from "../../../../../../store/api";
import { getAuthUserlocal } from "../../../../../../store/services";

export const submitBindingDispute = async (formData) => {
  try {
    const userId = getAuthUserlocal()._id;
    const response = await axios.post(
      getURLbyEndPointV2("createBindingDispute") + userId,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getBindingDisputeTrack = async () => {
  try {
    const userId = getAuthUserlocal()._id;
    const response = await axios.get(
      getURLbyEndPointV2("getBindingDispute") + userId
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}; 